import { FieldsPerStepType } from '../types';

export const FIELDS_PER_STEP: FieldsPerStepType = {
  1: ['email', 'password'],
  2: ['name', 'surname', 'phone'],
  3: ['terms', 'newsletter', 'phoneCallMarketing', 'phoneMessageMarketing'],
};
